document.addEventListener('DOMContentLoaded', function () {
    const headerGroup = document.querySelector('.shopify-section-group-header-group');
    const pageContent = document.querySelector('#main');

    if (!headerGroup || !pageContent) return;
    function loadPageContent(url) {
        document.body.classList.add('loading');
        return fetch(url)
            .then(response => {
                if (!response.ok) {
                    throw new Error('Network response was not ok');
                }
                return response.text();
            })
            .then(html => {
                const parser = new DOMParser();
                const doc = parser.parseFromString(html, 'text/html');

                const newPageContent = doc.querySelector('#main');
                if (newPageContent) {
                    pageContent.innerHTML = newPageContent.innerHTML;
                }
                history.pushState(null, '', url);
                document.body.classList.remove('loading');

const swatches = document.querySelectorAll('.block-swatch');
swatches.forEach((swatch, index) => {
  swatch.addEventListener('click', () => {
    const inputValue = swatch.querySelector('input').value;
    const rowScroll = document.querySelector('.row-scroll');
    const shopifyPaymentButton = document.querySelector('.shopify-payment-button');
    const addToCart = document.querySelector('#AddToCart');
    const addToCartFalse = document.querySelector('#AddToCartfalse');

    if (inputValue.includes('Custom Size')) {
      rowScroll.classList.add('hiddend');
      if (document.querySelector('.single_custom-size')) {
        document.querySelector('.single_custom-size').classList.remove('hiddend');
      }
      if (shopifyPaymentButton) shopifyPaymentButton.classList.add('hiddend');
      addToCart.classList.add('hiddend');
      addToCartFalse.classList.remove('hiddend');


      var inputsAndSelect = document.querySelectorAll('.check_valid');
var productForm = document.querySelector('.product-form');
var formId = productForm.getAttribute('form-ids'); 
  inputsAndSelect.forEach(function(elem) {
    elem.setAttribute('form', formId); 
  });
    } else {
      rowScroll.classList.remove('hiddend');
      if (document.querySelector('.single_custom-size')) {
        document.querySelector('.single_custom-size').classList.add('hiddend');
      }
      if (shopifyPaymentButton) shopifyPaymentButton.classList.remove('hiddend');
      addToCart.classList.remove('hiddend');
      addToCartFalse.classList.add('hiddend');

      var inputsAndSelect = document.querySelectorAll('.check_valid');
      inputsAndSelect.forEach(function(elem) {
        elem.value = '';
        elem.removeAttribute('form');
      });

      const tbody = document.querySelector('.row-scroll tbody');
      const rows = tbody.querySelectorAll('tr');
      const clickedRow = rows[index];
      rows.forEach((row) => {
        row.classList.remove('active');
        row.style.display = 'none';
      });
      clickedRow.classList.add('active');
      clickedRow.style.display = 'table-row';

      const activeIndex = Array.from(rows).indexOf(clickedRow);
      const numVisibleRows = 3;
      const totalRows = rows.length;

      const startIndex = Math.max(0, activeIndex - 1);
      const endIndex = Math.min(totalRows - 1, activeIndex + 1);

      rows.forEach((row, i) => {
        row.style.display = (i >= startIndex && i <= endIndex) ? 'table-row' : 'none';
      });

      const sizeValue = document.querySelector('#size-value-cici');
      sizeValue.textContent = swatch.querySelector('.block-swatch__item').textContent.trim();
    }
  });
});
var toggleCheckbox = document.getElementById('toggle');
if (toggleCheckbox) {
toggleCheckbox.addEventListener('click', function() {
  var tdElements = document.querySelectorAll('.row-scroll table td');
  var inputElements = document.querySelectorAll('.custom-option-properties input');
  var sizeElements = document.querySelectorAll('.custom-option-properties-size');
  for (var i = 0; i < tdElements.length; i++) {
    var tdElement = tdElements[i];
    var text = tdElement.textContent;

    if (text.includes('cm')) {
      var matches = text.match(/([\d½]+(?:\.\d+)?)/);
      if (matches && matches.length > 1) {
        var centimeters = parseFraction(matches[1]);
        var inches = centimeters / 2.54;
        var newText = inches.toFixed(1) + ' in';
        tdElement.setAttribute('data-original-text', text);
        tdElement.textContent = newText;
      }
    } else if (text.includes('in')) {
      var originalText = tdElement.getAttribute('data-original-text');
      if (originalText) {
        tdElement.textContent = originalText;
        tdElement.removeAttribute('data-original-text');
      }
    }
  }
  inputElements.forEach(function(input) {
        input.value = '';
    var sizeElement = input.nextElementSibling;
    var sizeText = sizeElement.textContent;
    if (sizeText.includes('cm')) {
      var placeholder = input.getAttribute('placeholder');
      if(placeholder){
              var minMax = placeholder.split(' - ');
      var newMin = Math.round(parseFloat(minMax[0]) / 2.54);
      var newMax = Math.round(parseFloat(minMax[1]) / 2.54);
      input.setAttribute('placeholder', newMin + ' - ' + newMax);
      input.setAttribute('min', newMin);
      input.setAttribute('max', newMax);
      }

    } else if (sizeText.includes('in')) {
      var placeholder = input.getAttribute('placeholder');
            if(placeholder){
              var minMax = placeholder.split(' - ');
      var newMin = Math.round(parseFloat(minMax[0]) * 2.54);
      var newMax = Math.round(parseFloat(minMax[1]) * 2.54);

      input.setAttribute('placeholder', newMin + ' - ' + newMax);
      input.setAttribute('min', newMin);
      input.setAttribute('max', newMax);
      }

    }
  });  
  sizeElements.forEach(function(sizeElement) {
    var sizeText = sizeElement.textContent;

    if (sizeText.includes('cm')) {
      sizeElement.textContent = '(in)';
    } else if (sizeText.includes('in')) {
      sizeElement.textContent = '(cm)';
    }
  });
});
}
function parseFraction(fraction) {
  var matches = fraction.match(/(\d+)(½|\.\d+)?/);
  if (matches && matches.length > 1) {
    var wholeNumber = parseInt(matches[1]);
    var decimalPart = matches[2] ? parseFloat(matches[2]) : 0;
    return wholeNumber + decimalPart;
  } else {
    return parseFloat(fraction);
  }
}

var inputFields = document.querySelectorAll('.custom-option-properties input[type="number"]');
var returnSupportCheckbox = document.querySelector('#return_support_checkbox');
var shopifyPaymentButton = document.querySelector('.shopify-payment-button');
var addToCart = document.querySelector('#AddToCart');
var addToCartFalse = document.querySelector('#AddToCartfalse');

function updateButtonVisibility() {
  var isAllInputsInRange = true;

  inputFields.forEach(function(input) {
    var value = parseFloat(input.value);
    var min = parseFloat(input.getAttribute('min'));
    var max = parseFloat(input.getAttribute('max'));

    if (isNaN(value) || value < min || value > max) {
      isAllInputsInRange = false;
      input.classList.add('false-input');
    } else {
      input.classList.remove('false-input');
    }
  });

  if (isAllInputsInRange && (!returnSupportCheckbox || returnSupportCheckbox.checked)) {
    if (shopifyPaymentButton) shopifyPaymentButton.classList.remove('hiddend');
    addToCart.classList.remove('hiddend');
    addToCartFalse.classList.add('hiddend');
    document.querySelector('.error_suggestion').textContent = "";
  } else {
    if (shopifyPaymentButton) shopifyPaymentButton.classList.add('hiddend');
    addToCart.classList.add('hiddend');
    addToCartFalse.classList.remove('hiddend');
  }
}

inputFields.forEach(function(input) {
  input.addEventListener('input', function() {
    setTimeout(function() {
      updateButtonVisibility();
    }, 0);
  });
});

if (returnSupportCheckbox) {
returnSupportCheckbox.addEventListener('click', function() {
  setTimeout(function() {
    updateButtonVisibility();
  }, 0);
});
}

// updateButtonVisibility();

document.addEventListener('DOMContentLoaded', function() {
  var selectedRadio = document.querySelector('.block-swatch__radio:checked');

  if (selectedRadio && selectedRadio.value.includes('Custom Size')) {
    if (shopifyPaymentButton) shopifyPaymentButton.classList.add('hiddend');
    addToCart.classList.add('hiddend');
    addToCartFalse.classList.remove('hiddend');

var inputsAndSelect = document.querySelectorAll('.check_valid');
var productForm = document.querySelector('.product-form');
var formId = productForm.getAttribute('form-ids'); 
  inputsAndSelect.forEach(function(elem) {
    elem.setAttribute('form', formId); 
  });
  } else {
    if (shopifyPaymentButton) shopifyPaymentButton.classList.remove('hiddend');
    addToCart.classList.remove('hiddend');
    addToCartFalse.classList.add('hiddend');

    var inputsAndSelect = document.querySelectorAll('.check_valid');
    inputsAndSelect.forEach(function(elem) {
      elem.removeAttribute('form');
      elem.classList.remove('false-input');
    });
  }
});

document.querySelector('#AddToCartfalse').addEventListener('click', function() {
  var inputFields = document.querySelectorAll('.custom-option-properties input[type="number"]');
  var returnSupportCheckbox = document.querySelector('#return_support_checkbox');
  var missingFields = [];

  inputFields.forEach(function(input) {
    var fieldName = input.getAttribute('name');
    fieldName = fieldName.replace('properties[', '').replace(']', '');
    if (input.value.trim() === '') {
      missingFields.push(fieldName);
    }
  });
  if (returnSupportCheckbox && !returnSupportCheckbox.checked) {
    missingFields.push('Please accept our terms and conditions');
  }
  var errorMessage = '';
  if (missingFields.length > 0) {
    errorMessage = 'Please provide: ' + missingFields.join(', ') + '.';
  }
  document.querySelector('.error_suggestion').textContent = errorMessage;
  if (missingFields.length === 0) {
    document.querySelector('#AddToCart').click();
  }
});

  var inputFieldsa = document.querySelectorAll('.custom-option-properties input[type="number"]');
        var selectFieldsa = document.querySelectorAll('.check_valid-select');
        inputFieldsa.forEach(function(input) {
            input.addEventListener('focus', function() {
                var description = this.previousElementSibling.getAttribute('data-description');
                var descElement = document.querySelector('#single_custom-size-desc');
                descElement.innerHTML = '';
                descElement.innerHTML = description;
            });
        });
        selectFieldsa.forEach(function(select) {
            select.addEventListener('change', function() {
                var description = this.previousElementSibling.getAttribute('data-description');
                var descElement = document.querySelector('#single_custom-size-desc');
                descElement.innerHTML = '';
                descElement.innerHTML = description;
            });
        });

applyTabLogic();
 adjustSliders();
  adjustaaaa();
     initializeSizeChart();           
       initializeVideoLink();    
            })
            .catch(error => {
                console.error('Error refreshing content:', error);
                alert('Page loading failed, please try again later.');
                document.body.classList.remove('loading');
            });
    }

    document.addEventListener('click', function (event) {
        const target = event.target.closest('.color-swatch-leo');

        if (target) {
            event.preventDefault();

            const url = target.getAttribute('data-handle'); 
            if (!url) {
                console.error('No URL found on the target element.');
                return;
            }

            if (document.body.classList.contains('loading')) return;

            loadPageContent(url);
        }
    });

    window.addEventListener('popstate', function () {
        const url = location.href;

        if (document.body.classList.contains('loading')) return;

        loadPageContent(url);
    });
});